export default "__VITE_ASSET__BXXkDCuw__"